import {Component, HostListener} from '@angular/core';
import {LaunchDialogService} from '@spartacus/storefront';

@Component({
  selector: 'dcp-cc-restricted-country-iframe',
  templateUrl: './cc-restricted-country-iframe.component.html',
  styleUrls: ['./cc-restricted-country-iframe.component.scss']
})
export class CcRestrictedCountryIframeComponent {
  sapComUrl = 'https://www.sap.com/registration/trial.908cb719-0e03-421c-a091-daca045f0acc.html';

  constructor(
    protected launchDialogService: LaunchDialogService
  ) {
  }

  @HostListener('document:keydown.escape')
  @HostListener('click', ['$event'])
  handleClickOrEsc(): void {
    this.launchDialogService.closeDialog('Cross click');
  }

  close(reason: string): void {
    this.launchDialogService.closeDialog(reason);
  }
}
